import { render, staticRenderFns } from "./ControllCenter.vue?vue&type=template&id=45141efe&scoped=true&"
import script from "./ControllCenter.vue?vue&type=script&lang=ts&"
export * from "./ControllCenter.vue?vue&type=script&lang=ts&"
import style0 from "./ControllCenter.vue?vue&type=style&index=0&id=45141efe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45141efe",
  null
  
)

export default component.exports